export default "__VITE_ASSET__BIPn7TgS__"